import Vue from 'vue'

const ENDPOINT = '/globals/config'
const REFRESH_LEADERBOARD_FALLBACK = 120
const REFRESH_GALLERY_FALLBACK = 300

const state = {
	roundSizeWeb: 10,
	roundSizeWall: 5,
	leaderboardRefreshInterval: 30,
	dialogue: {
		poked: [['Hey, ouch!'], ["C'mon, stop it ..."]]
	}
}

const toMs = (n, fallback) => (isNaN(n) ? fallback : Number(n)) * 1000

const getters = {
	leaderboardRefreshMs: state => {
		return toMs(state.leaderboardRefreshInterval, REFRESH_LEADERBOARD_FALLBACK)
	},
	galleryRefreshMs: state => {
		return toMs(state.galleryRefreshInterval, REFRESH_GALLERY_FALLBACK)
	}
}

const mutations = {
	set(state, data) {
		for (const [key, value] of Object.entries(data)) {
			Vue.set(state, key, value)
		}
	}
}

const actions = {
	async get({ dispatch, commit }) {
		const opts = { endpoint: ENDPOINT }
		try {
			const res = await dispatch('api/get', opts, { root: true })
			if (res.ok) commit('set', await res.json())
		} catch (err) {
			// Do nothing
		}
	},
	async set({ dispatch, commit }, data) {
		const opts = { endpoint: ENDPOINT, body: data }
		const res = await dispatch('api/post', opts, { root: true })
		const { value } = await res.json()
		commit('set', value)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
